import React from 'react';
import PropTypes from 'prop-types';
import colors from '../Theme/colors';

const dPath = 'M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z';

const uploadPropertyTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  title: PropTypes.string,
  fillColor: PropTypes.string,
};

type UploadProperties = PropTypes.InferProps<typeof uploadPropertyTypes> & {
  width?: string;
  height?: string;
  title?: string;
  fillColor?: string;
};

const Upload = ({
  width,
  height,
  title,
  fillColor = colors.greyDark,
}: UploadProperties) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
  >
    <title>{title}</title>
    <path
      d={dPath}
      fill={fillColor}
    />
  </svg>
);

Upload.propTypes = uploadPropertyTypes;

export default Upload;
